import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import * as styles from './AvatarLogo.style';
import StoreIcon from '@mui/icons-material/Store';
export const AvatarLogo = ({ logoUrl }) => {
    const [imgUrlError, setImgUrlError] = useState(false);
    const imgErrorHandler = () => {
        setImgUrlError(true);
    };
    return (React.createElement(Box, { sx: styles.content }, logoUrl && !imgUrlError ? (React.createElement(Avatar, { sx: styles.combination, "data-qa": "avatar", variant: "rounded", src: logoUrl, imgProps: {
            onError: imgErrorHandler,
        } })) : (React.createElement(Avatar, { "data-qa": "avatar", variant: "rounded", sx: styles.errorCombination },
        React.createElement(StoreIcon, { sx: styles.iconClass })))));
};
